import { Link } from "react-router-dom";
import { hasPermission } from "@tih/shared";
import { AdminHomepageVideoSection } from "../../components/admin/AdminHomepageVideoSection";
import { AdminIcon, type AdminIconName } from "../../components/admin/AdminIcon";
import { useAuth } from "../../context/AuthContext";

type HubCard = {
  to: string;
  label: string;
  description: string;
  icon: AdminIconName;
  feature: "content" | "events";
};

const CARDS: HubCard[] = [
  {
    to: "/admin/youtube",
    label: "Videos",
    description: "YouTube library and channel sync",
    icon: "video",
    feature: "content",
  },
  {
    to: "/admin/blog",
    label: "Blog",
    description: "Posts, drafts, and publishing",
    icon: "blog",
    feature: "content",
  },
  {
    to: "/admin/events",
    label: "Gallery",
    description: "Albums live on each event’s Album tab",
    icon: "gallery",
    feature: "events",
  },
  {
    to: "/admin/content",
    label: "Pages",
    description: "Standalone site pages",
    icon: "pages",
    feature: "content",
  },
  {
    to: "/admin/copy",
    label: "Marketing copy",
    description: "Landing and section copy strings",
    icon: "copy",
    feature: "content",
  },
];

export function AdminContentHubPage() {
  const { user } = useAuth();
  const canContent = hasPermission(user, "content");
  const cards = CARDS.filter((c) => hasPermission(user, c.feature));

  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <h1>Content</h1>
        <p>Videos, writing, galleries, pages, and the homepage video.</p>
      </header>

      {cards.length > 0 ? (
        <div className="admin-hub-grid">
          {cards.map((card) => (
            <Link key={card.to + card.label} to={card.to} className="admin-hub-card">
              <span className="admin-hub-card-icon" aria-hidden>
                <AdminIcon name={card.icon} size={22} />
              </span>
              <span className="admin-hub-card-body">
                <strong>{card.label}</strong>
                <span>{card.description}</span>
              </span>
            </Link>
          ))}
        </div>
      ) : (
        <div className="admin-hub-empty admin-card">
          <p>No content tools are available on this account.</p>
          <Link to="/admin" className="btn btn-ghost">
            Back to dashboard
          </Link>
        </div>
      )}

      {canContent && (
        <section className="admin-hub-section">
          <div className="admin-hub-section-head">
            <h2 className="admin-dashboard-heading">
              <AdminIcon name="homeVideo" size={20} /> Landing / home video
            </h2>
            <p className="admin-card-sub">
              Moved here from the dashboard. Accent colours still come from the featured
              event poster — this block only chooses which YouTube clip appears on the home.
            </p>
          </div>
          <AdminHomepageVideoSection />
        </section>
      )}
    </div>
  );
}
